.preview-text {
    padding-top: 56px;
    margin-bottom: 32px;
    text-align: center;
}

.preview-container {
    height: auto;
}
